import { VehicleTestData } from '../../../../../types/showcaseBlockType';
import { TestedVehicle } from '../../../../../types/TestedVehicle';

export const getSlugForLabel = (data: VehicleTestData[], value: string) => {
  const itemIndex = data.findIndex((item) => item.name === value);
  return itemIndex > -1 ? data[itemIndex].slug : undefined;
};

export const getVariantId = (variant: TestedVehicle) =>
  `${variant?.VariantId}-${variant?.TestedYear}-${variant?.TestedSeason}`;

export const getSeasonName = (season: string): string => {
  switch (season.toLowerCase()) {
    case 'winter':
      return 'vinter';
    default:
      return 'sommer';
  }
};
